// @ts-strict-ignore
import {reporter} from 'common/report/error-reporting';

import {ReportBasedCohorts, Serializable, SerializedReportBehaviorWrapper} from '../types/serialized-cohort-types';

export class Report implements Serializable {
  declare behavior_params?: any;
  declare average_behavior_params?: any;
  declare name: ReportBasedCohorts;
  declare bookmark: any;

  constructor(attrs: Partial<Report>) {
    Object.assign(this, attrs);
  }

  public serialize(): SerializedReportBehaviorWrapper {
    if (this.name === ReportBasedCohorts.Addiction) {
      return {
        [ReportBasedCohorts.Addiction]: {
          bookmark: this.bookmark,
          ...(this.behavior_params ? {behavior_params: this.behavior_params} : {}),
          ...(this.average_behavior_params ? {average_behavior_params: this.average_behavior_params} : {}),
        },
      };
    } else if (this.name === ReportBasedCohorts.Flows) {
      return {
        [ReportBasedCohorts.Flows]: {
          bookmark: this.bookmark,
          behavior_params: this.behavior_params,
        },
      };
    } else if (this.name === ReportBasedCohorts.Funnels) {
      return {
        [ReportBasedCohorts.Funnels]: {
          bookmark: this.bookmark,
          behavior_params: this.behavior_params,
        },
      };
    } else if (this.name === ReportBasedCohorts.Retention) {
      return {
        [ReportBasedCohorts.Retention]: {
          bookmark: this.bookmark,
          ...(this.behavior_params ? {behavior_params: this.behavior_params} : {}),
          ...(this.average_behavior_params ? {average_behavior_params: this.average_behavior_params} : {}),
        },
      };
    } else {
      reporter.error(`Report: Unexpected value for this.name`, this.name);
      return null;
    }
  }
}
